// extracted by mini-css-extract-plugin
module.exports = {"sun":"styles_sun__J_FLQ","loading-wheel":"styles_loading-wheel__3IaAn"};